import React, { useState } from 'react';
import './Header.css';
import { NavLink, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const noBgPages = ['/why', '/contact', '/book', '/packages', '/self-booking', '/rusttest'];
  const isNoBg = noBgPages.includes(location.pathname);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ client_name: '', client_phone: '' });
  const [status, setStatus] = useState(null);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setStatus(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({ client_name: '', client_phone: '' });
    setStatus(null);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('pending');

    try {
      // 1. Используем относительный путь, так как IIS проксирует запросы
      // 2. Добавляем технические поля оператора для общего коллбэка из шапки
      const payload = {
        ...formData,
        operator_name: "Общий отдел (Сайт)", // Чтобы в Telegram было понятно, откуда заявка
        operator_phone: "Основной номер"
      };

      const response = await fetch('/api/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Failed to submit callback request');

      const responseData = await response.json();
      setStatus('success');
      setFormData({ client_name: '', client_phone: '' });
      
      // Закрываем модалку чуть позже, чтобы пользователь увидел "Успех"
      setTimeout(() => {
        setIsModalOpen(false);
      }, 2000);

      console.log('Submission successful:', responseData);
    } catch (error) {
      setStatus('error');
      console.error('Submission error:', error);
    }
  };

  return (
    <>
      <header className={`main-header ${isNoBg ? 'no-bg' : ''}`}>
        <div className="header-container">
          <NavLink to="/" className="logo-text">
            ASIAN TOUR
          </NavLink>

          <nav className="header-nav">
            <ul>
              <li className="header-second__li">
                <NavLink to="/packages">Премиальные предложения</NavLink>
              </li>
              <li>
                <NavLink to="/book">Бронируйте с нами</NavLink>
              </li>
              <li>
                <NavLink to="/self-booking">Сам бронирую</NavLink>
              </li>
              <li>
                <NavLink to="/why">Почему Asian Tour</NavLink>
              </li>
              <li>
                <NavLink to="/contact">Контакты</NavLink>
              </li>
            </ul>
          </nav>

          <div className="header-cta">
            <button onClick={handleOpenModal} className="call-me-back-btn">
              Перезвоните мне
            </button>
          </div>
        </div>
      </header>

      {isModalOpen && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target.classList.contains('modal-overlay')) handleCloseModal();
          }}
        >
          <div className="modal-content">
            <h2>Мы вам перезвоним</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="client_name"
                placeholder="Ваше имя"
                value={formData.client_name}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #ddd', marginBottom: 10 }}
              />
              <input
                type="tel"
                name="client_phone"
                placeholder="Номер телефона"
                value={formData.client_phone}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #ddd', marginBottom: 10 }}
              />
              <div className="modal-buttons">
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={status === 'pending'}
                  style={{
                    padding: '10px 20px',
                    borderRadius: 10,
                    border: 'none',
                    background: 'linear-gradient(135deg,#0d6efd,#6f42c1)',
                    color: '#fff',
                    cursor: status === 'pending' ? 'not-allowed' : 'pointer'
                  }}
                >
                  {status === 'pending' ? 'Отправляю...' : 'Отправить'}
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={handleCloseModal}
                  style={{
                    padding: '10px 20px',
                    borderRadius: 10,
                    border: '1px solid #ddd',
                    background: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  Закрыть
                </button>
              </div>
              {status === 'success' && (
                <div style={{ color: 'green', marginTop: 10, fontWeight: 'bold' }}>
                   ✅ Заявка отправлена. Мы свяжемся с вами.
                </div>
              )}
              {status === 'error' && (
                <div style={{ color: 'crimson', marginTop: 10, fontWeight: 'bold' }}>
                   ❌ Ошибка отправки. Попробуйте ещё раз.
                </div>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;